import {Box} from "@cdx/ds";
import {useLayoutEffect, useRef} from "react";
import {cameraToWorld, VisionBoardBag} from "./canvas-utils";

type SelectionBoxProps = {
  startPos: [number, number];
  onMousePosCbRef: React.MutableRefObject<((pos: [number, number]) => void) | null>;
  bag: VisionBoardBag;
};
const CanvasSelectionBox = (props: SelectionBoxProps) => {
  const {startPos, onMousePosCbRef} = props;
  const {posRef, store, selectionStore} = props.bag;
  const nodeRef = useRef<HTMLDivElement>(null);
  useLayoutEffect(() => {
    const [sx, sy] = cameraToWorld(startPos, posRef);
    let currPos = startPos;
    const draw = () => {
      const [x, y] = cameraToWorld(currPos, posRef);
      const [minX, maxX] = x < sx ? [x, sx] : [sx, x];
      const [minY, maxY] = y < sy ? [y, sy] : [sy, y];
      nodeRef.current!.style.left = `${minX}px`;
      nodeRef.current!.style.top = `${minY}px`;
      nodeRef.current!.style.width = `${maxX - minX}px`;
      nodeRef.current!.style.height = `${maxY - minY}px`;
      const nodes = store.getNodesSnapshot({minX, minY, maxX, maxY});
      selectionStore.setNodeIds(nodes.map((n) => n.id));
    };
    draw();

    onMousePosCbRef.current = (nextPos) => {
      currPos = nextPos;
      draw();
    };
    return () => {
      onMousePosCbRef.current = null;
    };
  }, [posRef, startPos, onMousePosCbRef, store, selectionStore]);
  return (
    <Box
      absolute
      style={{border: "1px solid cyan", background: "rgba(0, 0, 255, 0.1)"}}
      ref={nodeRef}
    />
  );
};

export default CanvasSelectionBox;
